import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHumanTrackSwitch } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 人形追踪开关状态
  humanTrackSwitch: {
    data: {},
    query: {}
  }
};

// 获取人形追踪开关状态
export const fetchHumanTrackSwitch = createAsyncThunk(
  'ys7Track/fetchHumanTrackSwitch',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getHumanTrackSwitch(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取人形追踪开关状态失败');
    }
  }
);

const trackSlice = createSlice({
  name: 'ys7Track',
  initialState: defaultState,
  reducers: {
    resetTrackState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchHumanTrackSwitch
      .addCase(fetchHumanTrackSwitch.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.humanTrackSwitch.query = action.meta.arg || {};
      })
      .addCase(fetchHumanTrackSwitch.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.humanTrackSwitch.data = action.payload?.data?.data || action.payload?.data || {};
        state.humanTrackSwitch.query = action.payload?.query || {};
      })
      .addCase(fetchHumanTrackSwitch.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.humanTrackSwitch.data = {};
      });
  }
});

export const { resetTrackState } = trackSlice.actions;
export default trackSlice.reducer;
